module.exports = __webpack_public_path__ + "img/pubcom.eda17c5.svg";